import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import CustomLoading from '../util_components/custom_loading';
import * as actions from '../../redux/action_creators';
import { ianaTimezones } from '../../constants';

import Drawer from '../views/drawer';
import ThemeToggle from '../util_components/ThemeToggle';
import StudentProfiles from '../views/student_profiles';
import TeachersList from '../views/teachers/teachers_list';
import TrialPointsList from '../views/trial_points';
import TrialPointsTeacherDetail from '../views/trial_points/teacher_detail';
import TeacherProfile from '../views/teachers/teacher_profile';
import TeacherRepeatSessions from '../views/teachers/repeat_sessions';
import TeacherTransactions from '../views/teachers/teacher_transactions';
import TeacherEmailLogs from '../views/teachers/teacher_email_logs';
import TeacherAreaMap from '../views/teachers/teacher_area_map';
import TeacherMatch from '../views/teacher_match';
import Events from '../views/events';
import EventDetail from '../views/events/event_detail';
import SupportInbox from '../views/support_inbox';

import TeacherAvailability from '../views/reports/availability_all_teachers';
import ConsultTeacherAvailability from '../views/reports/availability_all_teachers/consult_availability';
import StudentsAndSessions from '../views/reports/students_sessions';
import AllStudentTransactions from '../views/reports/all_student_transactions';
import SessionsReport from '../views/reports/sessions_report';
import Referrals from '../views/reports/referrals';
import YogaCuesLibrary from '../views/reports/yoga_cues_library';
import TeacherSessionsStats from '../views/reports/teacher_sessions_stats';
import StudentSessionsStats from '../views/reports/student_sessions_stats';
import CareMessages from '../views/reports/care_messages';
import CohortTimeBased from '../views/reports/cohort_time_based';
import KeyMetrics from '../views/reports/key_metrics';
import SessionsWeekly from '../views/reports/sessions_weekly';
import GroupSessionsReport from '../views/reports/group_sessions_report';
import GroupSessionsByDate from '../views/reports/grp_sess_by_date';
import EmailDeliveryReport from '../views/reports/email_delivery_report';
import EmailDeliveryReportDay from '../views/reports/email_delivery_report_day';
import Replacement from '../views/reports/replacement';
import NewUsers from '../views/reports/new_users';
import Chargebacks from '../views/reports/chargebacks';
import ChargebackDetails from '../views/reports/chargebacks/details';
import SmsReport from '../views/reports/sms_report';
import SmsReportV3 from '../views/reports/sms_report_v3';
import FlaggedSMS from '../views/reports/flagged_sms';
import FailedRecurringTransactions from '../views/reports/failed_recurring_transactions';
import BannedStudents from '../views/reports/banned_students';
import ExtraParticipantCharges from '../views/reports/extra_participant_charges';
import MembershipCancellations from '../views/reports/membership_cancellations';
import ManualCropping from '../views/reports/manual_cropping';
import BlockedMessages from '../views/profanity_filter/blocked_messages';
import CouponOffers from '../views/coupons';
import CouponOfferDetails from '../views/coupons/details';
import Concierge from '../views/reports/concierge';
import ConciergeV2 from '../views/reports/concierge_v2';
import ConciergeV3 from '../views/reports/concierge_v3';
import ConciergePostTrialBuckets from '../views/reports/concierge_post_trial_buckets';
import NutritionProgramPayments from '../views/reports/nutrition_program_payments';

import FutureSessions from '../views/sessions/future_sessions';
import PastSessions from '../views/sessions/past_sessions';
import SessionViewer from '../views/sessions/session_viewer';
import UserSessions from '../views/sessions/user_sessions';
import SingleSessionDetails from '../views/sessions/single_session_details';
import SessionAnalytics from '../views/sessions/session_analytics';
import ReplacementSessions from '../views/sessions/replacement_sessions';
import ReplacementSessionTeachers from '../views/sessions/replacement_session_teachers';
import CancelledSessions from '../views/sessions/cancelled_sessions';
import CropRecording from '../views/sessions/crop_recording';
import FriendsSessions from '../views/sessions/friends_sessions';
import PastFriendsSessions from '../views/sessions/past_friends_sessions';
import RecommendationsPlayground from '../views/sessions/RecommendationsPlayground';
import RequestSessionDashboard from '../views/sessions/request_session_dashboard';

import GroupSessionDetails from '../views/classes/class_details';
import GroupSessions from '../views/classes/future_classes';
import RepeatGroupsessions from '../views/classes/repeat_group_classes.jsx';
import CreateGroupSessions from '../views/classes/create_group_sessions';
import PastGroupSessions from '../views/classes/past_classes';
import RecommendedGroupSessions from '../views/classes/recommeded_classes';

import StudentsList from '../views/students/students_list';
import LiveUsers from '../views/students/live_users';
import StudentProfile from '../views/students/student_profile';
import TwilioAgent from '../views/twilio_agent';
import StudentProfileTests from '../views/students/student_tests';
import StudentEmailLogs from '../views/students/email_logs';
import AddRoadmap from '../views/students/add_roadmap';
import StudentTransactions from '../views/students/student_transactions';
import CreditHistory from '../views/students/credit_history';
import Preferences from '../views/students/notification_preferences';
import StudentRepeatSession from '../views/students/repeat_sessions';
import StudentNotifications from '../views/students/notifications';

import EmailTemplates from '../views/email_templates';
import CreateEmail from '../views/other/create_email';
import BlockedDevices from '../views/other/blocked_devices';
import DownloadData from '../views/other/download_data';
import NewTesting from '../views/other/testing';
import Invalidate from '../views/other/invalidate';
import TeacherPayments from '../views/other/upload_teacher_payment';
import Inventory from '../views/other/inventory';
import PressPages from '../views/other/press_pages';
import PricingLinks from '../views/other/pricing_links';
import ConciergePods from '../views/other/concierge_pods';
import ConciergePodsReport from '../views/other/concierge_pods_report';
import ConciergePodsTeamAssignments from '../views/other/concierge_pods_team_assignments';
import ConciergePodsReassignments from '../views/other/concierge_pods_reassignments';
import ConciergePodsRegions from '../views/other/concierge_pods_regions';
import ProfanityList from '../views/profanity_filter/profanity_list';
import CmsUsers from '../views/other/cms_users';
import CmsUsersConfig from '../views/other/cms_users_config';
import TwilioAvailabilityToggle from '../views/twilio_agent/AvailabilityToggle';

import EmailTemplatesNew from '../views/emails/templates';

import HealthKeywords from '../views/classes/health_keywords';
import GroupClassTypes from '../views/classes/group_class_types';
import GroupClassPages from '../views/classes/group_class_pages';
import ClassPageDetails from '../views/classes/class_page_details';

import SplitTesting from '../views/split_testing';
import SplitTestingV2 from '../views/split_testing_v2';
import UploadImages from '../views/other/upload_images';

import Announcements from '../views/announcements';
import AnnouncementDetails from '../views/announcements/details';
import MinorVersionDetails from '../views/announcements/minor_version_details';

import Workshops from '../views/workshops';
import WorkshopDetails from '../views/workshops/workshop_details';
import WorkshopSession from '../views/workshops/workshop_session';

import HealthMarker from '../views/health_marker';

import PastConsults from '../views/consults/past';
import FutureConsults from '../views/consults/future';
import ConsultDetails from '../views/consults/details';

import CommunityClassesRequest from '../views/community_classes';
import PromoteGrpClass from '../views/promote_grp_class';

import Groups from '../views/ywf_groups';
import GroupDetails from '../views/ywf_groups/group_details';

import UserTimeline from '../views/user_timeline';

import ContentTags from '../views/content/tags';
import ContentTagsBySlug from '../views/content/tags_content';
import ContentBlogs from '../views/content/blogs';

import TagAssociations from '../views/content/tag_associations';

import './home.css';

import { ChatWindowManager } from '../chat/chat';
import InactiveMembers from '../views/reports/inactive_members';
import MagicLinkCampaigns from '../views/magic_link_campaigns';
import index from '../views/FeedbackForm';
import CreateSessionFeedback from '../views/FeedbackForm/createSessionFeedback';
import SessionFeedbackFormDetails from '../views/FeedbackForm/SessionFeedbackFormDetails';
import EditSessionFeedback from '../views/FeedbackForm/EditSessionFeedback';
import { ChatClient } from '../../myt_chat/worker/chatProxies';
import { CallbackHandler } from '../../myt_chat/chat/callbacks/handler';
import UserRole from '../../myt_chat/chat/enums/UserRole';
import MytNotification from '../../myt_chat/notification';
import GlobalIncomingCallManager from '../views/twilio_agent/GlobalIncomingCallManager';
import GlobalOutboundCallManager from '../views/twilio_agent/GlobalOutboundCallManager';
import MembershipCreditHistory from '../views/students/student_profile/MembershipCreditHistory';
import TeacherNotificationPreferences from '../views/teachers/notification_preferences/TeacherNotificationPreferences';
import TeacherNotificationPreferencesHistory from '../views/teachers/notification_preferences/TeacherNotificationPreferencesHistory';
import GptSessionNotes from '../views/LLM_Session';
import SessionSummary from '../views/LLM_Session/SessionSummary';
import GroupChats from '../views/chat_groups';
import ShortUrlLinks from '../views/short_url_links';
import ZoomMeetingUsers from '../views/Zoom_meetings_users';
import EmailTimeline from '../views/email_timeline';
import TimezoneDropdown from '../util_components/TimezoneDropDown';
import VideoChapters from '../views/sessions/VideoChapters';
import GptSessionQaScores from '../views/LLM_Session/qa_scores.jsx';
import InvalidateCache from '../views/content/InvalidateCache';
import TeacherApplication from '../views/teachers/application/TeacherApplication.jsx';
import PersonalizedPlanPage from '../views/students/personalised_plan_page';
import Reminders from '../views/reminders';
import EarlyRetentionChecklist from '../views/early_retention_checklist';
import EarlyRetentionChecklistFormPage from '../views/early_retention_checklist/form_page';
import SalesTaskList from '../views/sales_task_list';
import SalesTaskFormPage from '../views/sales_task_list/form_page';
import Profile from '../views/profile';

class Home extends Component {
  constructor(props) {
    super(props);

    const on_support_page = window.location.pathname.split('/')[1] === 'support';
    this.state = {
      // Keep the main left nav collapsed by default on the Support Inbox page.
      drawer_open: on_support_page ? false : window.innerWidth > 700
    };
  }

  incomingCallRelayHandler = (item) => {
    if (!item || !item.data) return;

    const relayType = item.data.type;

    if (relayType === 'availability_changed') {
      window.dispatchEvent(
        new CustomEvent('twilio-agent-availability-changed', {
          detail: {
            available: !!item.data.available,
            ops_uuid: item.data.ops_uuid || ''
          }
        })
      );
      return;
    }

    if (relayType === 'recent_call_finished') {
      window.dispatchEvent(
        new CustomEvent('twilio-recent-calls-update', {
          detail: { call: item.data.call }
        })
      );
      return;
    }

    // CRM reminder alert. Published by goserver's crm consumer alongside
    // the WhatsApp send so the assignee gets a desktop notification even
    // when their phone is silenced. Click navigates to the linked user's
    // profile (student/teacher) when known, otherwise the reminders
    // dashboard. The tag key includes the alert uuid so duplicate
    // deliveries dedupe at the OS notification layer.
    if (relayType === 'crm_reminder_alert') {
      const reminderTitle = item.data.title || 'Reminder';
      const linkedUuid = item.data.linked_user_uuid;
      const linkedRole = item.data.linked_user_role;
      const linkedName = item.data.linked_user_name;
      // Title shape requested by ops:
      //   "Reminder: [Student]: <name>"   or
      //   "Reminder: [Teacher]: <name>"
      // Falls back to a bare "Reminder" header when no linked user is set.
      let notificationTitle = 'Reminder';
      if (linkedName && linkedRole === 'teacher') {
        notificationTitle = `Coach Reminder: ${linkedName}`;
      } else if (linkedName && linkedRole === 'student') {
        notificationTitle = `Student Reminder: ${linkedName}`;
      }
      // Body is just the task text — the title row already names the user.
      const body = reminderTitle;
      const tag = `crm-reminder-${item.data.alert_uuid || item.id}`;
      let target = '/reminders';
      if (linkedUuid && linkedRole === 'teacher') {
        target = `/teacherprofile?id=${encodeURIComponent(linkedUuid)}`;
      } else if (linkedUuid && linkedRole === 'student') {
        target = `/studentprofile?id=${encodeURIComponent(linkedUuid)}`;
      }
      MytNotification.showLocalNotification(
        tag,
        body,
        () => {
          try {
            window.focus();
            if (window.location.pathname + window.location.search !== target) {
              this.props.history.push(target);
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error('crm reminder notification click nav failed', err);
          }
        },
        notificationTitle
      );
      return;
    }

    // New inbound support email. Published by goserver's support inbound
    // pipeline (support/inbound.go) alongside the silent inbox data-sync push,
    // so agents get a desktop notification for new customer mail on any hridaya
    // page — not just while /support is open. Recipients are the assignee when
    // the ticket is assigned, otherwise every support agent (server-side).
    // Click navigates to the ticket in the support inbox. The tag includes the
    // message uuid so duplicate deliveries dedupe at the OS notification layer.
    if (relayType === 'support_inbound_email') {
      const from = item.data.from || 'a customer';
      const subject = item.data.subject || '(no subject)';
      const ticketNumber = item.data.ticket_number;
      const convUuid = item.data.conversation_uuid;
      const snippet = item.data.preview;
      const notificationTitle = ticketNumber ? `New email · #${ticketNumber}` : 'New support email';
      // Body leads with the sender + subject; append the snippet when present.
      let body = `${from}: ${subject}`;
      if (snippet) body += `\n${snippet}`;
      const tag = `support-email-${item.id}`;
      const target = convUuid ? `/support?tkt=${encodeURIComponent(convUuid)}` : '/support';
      MytNotification.showLocalNotification(
        tag,
        body,
        () => {
          try {
            window.focus();
            if (window.location.pathname + window.location.search !== target) {
              this.props.history.push(target);
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error('support email notification click nav failed', err);
          }
        },
        notificationTitle
      );
      return;
    }

    // Global missed-call notification. Fired by the server at every moment
    // an inbound call failed to reach a live agent — caller hung up while
    // ringing, rolled to voicemail (with or without leaving a message), or
    // hit the no-agents / all-busy fast-paths. We surface a system push
    // (with sound) on every hridaya page so ops aren't dependent on having
    // /twilio-agent open to know they were missed. The OS-level tag dedupes
    // duplicate emits for the same call. Click navigates to /twilio-agent
    // where Recent Calls shows the row + voicemail player if applicable.
    if (relayType === 'missed_call') {
      const studentName = item.data.student_first_name;
      const studentUuid = item.data.student_uuid;
      const fromNumber = item.data.from_number || 'Unknown';
      const reason = item.data.reason || 'Missed call';
      const body = studentName
        ? `Missed call from ${studentName} (${fromNumber}) — ${reason}`
        : `Missed call from ${fromNumber} — ${reason}`;
      const tag = `missed-${item.data.call_uuid || item.id}`;
      // Click destination prioritises the student profile when the inbound
      // number resolved to a student — the agent gets full context (plan,
      // history, prior calls) one click away, instead of needing a second
      // hop through /twilio-agent. Falls back to /twilio-agent for unknown
      // PSTN callers, where Recent Calls is the only meaningful destination.
      const target = studentUuid
        ? `/studentprofile?id=${encodeURIComponent(studentUuid)}`
        : '/twilio-agent';
      MytNotification.showLocalNotification(tag, body, () => {
        try {
          window.focus();
          if (window.location.pathname + window.location.search !== target) {
            this.props.history.push(target);
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('missed call notification click nav failed', err);
        }
      });
      return;
    }

    // Global fresh-lead notification. Published by goserver's sales_task_list
    // service the moment a FRESH_LEAD task row is inserted (lifecycle hook or
    // the 5-minute sweep) — targeted at the assignee when the row has one,
    // otherwise broadcast to every care agent. Surfaced as a system push (with
    // sound) on every hridaya page so a lead gets called within minutes of
    // signing up, without anyone camping on /sales-task-list. The OS-level tag
    // includes the task uuid so duplicate deliveries collapse. Click navigates
    // to the sales task list, where the new row is at the top of the queue.
    if (relayType === 'fresh_lead') {
      const studentName = item.data.student_name;
      const studentPhone = item.data.student_phone;
      // Body leads with who to call; append the number when the row has one.
      let body = studentName ? `New signup: ${studentName}` : 'New signup';
      if (studentPhone) body += ` (${studentPhone})`;
      const tag = `fresh-lead-${item.data.task_uuid || item.id}`;
      const target = '/sales-task-list';
      MytNotification.showLocalNotification(
        tag,
        body,
        () => {
          try {
            window.focus();
            if (window.location.pathname + window.location.search !== target) {
              this.props.history.push(target);
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error('fresh lead notification click nav failed', err);
          }
        },
        'Fresh lead — call now'
      );
      return;
    }

    const callSid = item.data.call_sid || item.id;
    if (!callSid) return;
    const ringId = `incoming-call-${callSid}`;

    if (relayType === 'incoming_call_ended') {
      MytNotification.stopIncomingCallRing(ringId);
      return;
    }

    if (relayType !== 'incoming_call') return;

    const studentName = item.data.student_name;
    const fromNumber = item.data.from_number || 'Unknown';
    const body = studentName
      ? `Incoming call from ${studentName} (${fromNumber})`
      : `Incoming call from ${fromNumber}`;

    MytNotification.startIncomingCallRing(ringId, body, () => {
      try {
        window.focus();
        if (window.location.pathname !== '/twilio-agent') {
          this.props.history.push('/twilio-agent');
        }
      } catch (err) {
        console.error('incoming call ring click nav failed', err);
      }
    });
  };

  // Support-inbox note @mention. The server sends a dedicated, targeted
  // realtime packet ("mention.new") to the tagged agent's websocket (see
  // goserver support/api_mutations.go). Because ChatClient is initialized
  // globally in this shell's componentDidMount, that packet reaches
  // CallbackHandler.callOnSupportEmailPacket on every page — but the only
  // other subscriber (the Support Inbox page) is torn down on unmount, so
  // without this global listener the mention is dropped whenever the agent
  // is elsewhere. Here we surface a desktop notification on any page, in the
  // same style as the support_inbound_email relay handler above. The Support
  // Inbox page keeps its own in-app toast + list refresh for mention.new, so
  // we skip the OS notification while /support is open to avoid double-
  // notifying; the OS-level tag (note id) dedupes duplicate deliveries.
  supportMentionPacketHandler = (packet) => {
    if (!packet || packet.event !== 'mention.new') return;
    // On the Support Inbox page the local handler already shows an in-app
    // toast — don't stack a redundant desktop notification on top of it.
    if (window.location.pathname.split('/')[1] === 'support') return;

    const data = packet.data || {};
    const ticketNumber = data.ticket_number;
    const authorName = data.author_name || 'Someone';
    const snippet = data.note_snippet;
    const convUuid = data.conversation_uuid;
    const notificationTitle = ticketNumber
      ? `You were mentioned · #${ticketNumber}`
      : 'You were mentioned';
    // Body leads with who mentioned you; append the note snippet when present.
    let body = authorName;
    if (snippet) body += `: ${snippet}`;
    const tag = `support-mention-${data.note_id || packet.id}`;
    const target = convUuid ? `/support?tkt=${encodeURIComponent(convUuid)}` : '/support';
    MytNotification.showLocalNotification(
      tag,
      body,
      () => {
        try {
          window.focus();
          if (window.location.pathname + window.location.search !== target) {
            this.props.history.push(target);
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('support mention notification click nav failed', err);
        }
      },
      notificationTitle
    );
  };

  smsHandler = (item) => {
    if (
      item.from.role === UserRole.STUDENT &&
      item.from.user === '1f4d13c1-4710-420f-992f-f6e9d258932b'
    ) {
      const alertText = `Incoming SMS \nStudent: ${item.from.name}\nText: ${item.text}`;
      alert(alertText);
    } else {
      console.log(
        `SMS received from: ${item.from.role}:${item.from.name} to ${item.to.role}:${item.to.name}, text: ${item.text}`
      );
    }
  };

  componentDidMount() {
    this.props.get_permissions();
    if (this.props.config_status === 'none') {
      this.props.get_config();
    }

    ChatClient.shared.initialize();
    CallbackHandler.shared.registerSMSHandler(this.smsHandler);
    CallbackHandler.shared.registerRelayItemListener(this.incomingCallRelayHandler);
    CallbackHandler.shared.registerSupportEmailListener(this.supportMentionPacketHandler);
  }

  componentDidUpdate(prevProps) {
    const prev_path = (prevProps.location && prevProps.location.pathname) || '';
    const curr_path = (this.props.location && this.props.location.pathname) || '';
    // On navigating into the Support Inbox page, collapse the main left nav by default.
    // Only fires on the route change, so a manual re-expand while on the page still sticks.
    if (
      curr_path !== prev_path &&
      curr_path.split('/')[1] === 'support' &&
      this.state.drawer_open
    ) {
      this.setState({ drawer_open: false });
    }
  }

  componentWillUnmount() {
    CallbackHandler.shared.unregisterSMSHandler(this.smsHandler);
    CallbackHandler.shared.unregisterRelayItemListener(this.incomingCallRelayHandler);
    CallbackHandler.shared.unregisterSupportEmailListener(this.supportMentionPacketHandler);
  }

  toggle_drawer = () => {
    this.setState({ drawer_open: !this.state.drawer_open });
  };

  set_time_zone = (e) => this.props.set_home_variable('iana_timezone', e.target.value);

  render_switch = () => {
    const { access_pages } = this.props;
    const single_path = `/${window.location.pathname.split('/')[1]}`;
    const always_accessible = ['/profile', '/health_marker', '/request_session_dashboard'];
    if (access_pages.indexOf(single_path) === -1 && !always_accessible.includes(single_path)) {
      const url = access_pages[0];
      return <Redirect to={url} />;
    }
    return (
      <Switch>
        <Route path="/student_profiles" component={StudentProfiles} />
        <Route path="/studentsandsessions" component={StudentsAndSessions} />
        <Route path="/allstudenttransactions" component={AllStudentTransactions} />
        <Route path="/chargebacks" component={Chargebacks} />
        <Route path="/nutrition_program_payments" component={NutritionProgramPayments} />
        <Route path="/chargebackdetails" component={ChargebackDetails} />
        <Route path="/teacherprofile" component={TeacherProfile} />
        <Route path="/teacherslist" component={TeachersList} />
        <Route exact path="/trial_points" component={TrialPointsList} />
        <Route path="/trial_points/:teacher_uuid" component={TrialPointsTeacherDetail} />
        {/* PROD-8461. `exact` on the list route matters: without it /events/:slug
            renders the list instead of the detail screen. */}
        <Route exact path="/events" component={Events} />
        <Route path="/events/:slug" component={EventDetail} />
        <Route exact path="/teacher-match" component={TeacherMatch} />
        <Route path="/support" component={SupportInbox} />
        <Route path="/teachertransactions" component={TeacherTransactions} />
        <Route path="/availability/consult" component={ConsultTeacherAvailability} />
        <Route path="/availability" component={TeacherAvailability} />
        <Route exact path="/sessions/backpain" component={FutureSessions} />
        <Route exact path="/pastsessions/backpain" component={PastSessions} />
        <Route path="/request_session_dashboard" component={RequestSessionDashboard} />
        <Route path="/sessions" component={FutureSessions} />
        <Route path="/pastsessions" component={PastSessions} />
        <Route path="/usersessions/future" component={UserSessions} />
        <Route
          path="/teacher/notification_preferences"
          component={TeacherNotificationPreferences}
        />
        <Route
          path="/teacher/notification_preferences_history"
          component={TeacherNotificationPreferencesHistory}
        />
        <Route path="/usersessions/past" component={UserSessions} />
        <Route exact path="/groupsessions" component={GroupSessions} />
        <Route exact path="/groupsessions/repeat" component={RepeatGroupsessions} />
        <Route exact path="/backpain/groupsessions" component={GroupSessions} />
        <Route exact path="/backpain/pastgroupsessions" component={PastGroupSessions} />
        <Route exact path="/membership_cancellations" component={MembershipCancellations} />
        <Route exact path="/sessions-for-manual-cropping" component={ManualCropping} />

        <Redirect exact from="/groupsessions/recommended" to="/groupsessions/recommended/future" />
        <Route
          path="/groupsessions/recommended/:page_status"
          component={RecommendedGroupSessions}
        />
        <Route path="/creategroupsessions" component={CreateGroupSessions} />
        <Route path="/pastgroupsessions" component={PastGroupSessions} />
        <Route path="/sessiondetails" component={SingleSessionDetails} />
        <Route path="/session_analytics" component={SessionAnalytics} />
        <Route path="/recommendations_playground" component={RecommendationsPlayground} />
        <Route
          path="/replacementsessions/:replacementRequestID"
          component={ReplacementSessionTeachers}
        />
        <Route path="/replacementsessions" component={ReplacementSessions} />
        <Route path="/groupsessiondetails" component={GroupSessionDetails} />
        <Route path="/cancelledsessions" component={CancelledSessions} />
        <Route path="/session_replay" component={SessionViewer} />
        <Route exact path="/friends_sessions" component={FriendsSessions} />
        <Route exact path="/friends_sessions/past" component={PastFriendsSessions} />
        <Route path="/users" component={StudentsList} />
        <Route path="/liveusers" component={LiveUsers} />
        <Route exact path="/studentprofile" component={StudentProfile} />
        <Route exact path="/twilio-agent" component={TwilioAgent} />
        <Route exact path="/membership_credits_history" component={MembershipCreditHistory} />
        <Route path="/studentprofile/tests/:slug" component={StudentProfileTests} />
        <Route path="/studentemaillogs" component={StudentEmailLogs} />
        <Route path="/addroadmap" component={AddRoadmap} />
        <Route path="/studenttransactions" component={StudentTransactions} />
        <Route path="/sessionsreport" component={SessionsReport} />
        <Route path="/referrals" component={Referrals} />
        <Route path="/teachersessionstats" component={TeacherSessionsStats} />
        <Route path="/studentsessionstats" component={StudentSessionsStats} />
        <Route path="/caremessages" component={CareMessages} />
        <Route path="/credithistory" component={CreditHistory} />
        <Route path="/student/notification_preferences" component={Preferences} />
        <Route path="/emailtemplates" component={EmailTemplates} />
        <Route path="/cohorttimebased" component={CohortTimeBased} />
        <Route path="/keymetrics" component={KeyMetrics} />
        <Route path="/weekly_report" component={SessionsWeekly} />
        <Route path="/groupsessionsreport" component={GroupSessionsReport} />
        <Route path="/grpsessionreportdate" component={GroupSessionsByDate} />
        <Route path="/createemail" component={CreateEmail} />
        <Route path="/croprecording" component={CropRecording} />
        <Route path="/split_testing" component={SplitTesting} />
        <Route path="/split_testing/past" component={SplitTesting} />
        <Route path="/split_test_v2" component={SplitTestingV2} />
        <Route path="/upload_images" component={UploadImages} />
        <Route path="/workshops" component={Workshops} />
        <Route exact path="/health_marker" component={HealthMarker} />
        <Route exact path="/workshop/:uuid" component={WorkshopDetails} />
        <Route exact path="/workshop/session" component={WorkshopSession} />
        <Route exact path="/emaildeliveryreport" component={EmailDeliveryReport} />
        <Route exact path="/emaildeliveryreport/day" component={EmailDeliveryReportDay} />
        <Route path="/health_keywords" component={HealthKeywords} />
        <Route path="/group_class_types" component={GroupClassTypes} />
        <Route path="/repeat_sessions/teacher" component={TeacherRepeatSessions} />
        <Route path="/repeat_sessions" component={StudentRepeatSession} />
        <Route path="/group_class_pages" component={GroupClassPages} />
        <Route path="/backpain/group_class_pages" component={GroupClassPages} />

        <Route path="/group_class_page/:page_slug" component={ClassPageDetails} />
        <Route path="/pastreplacements" component={Replacement} />
        <Route path="/blocked_devices" component={BlockedDevices} />
        <Route exact path="/coupon_offers" component={CouponOffers} />
        <Route exact path="/coupon_offers/:uuid" component={CouponOfferDetails} />
        <Route exact path="/announcements" component={Announcements} />
        <Route exact path="/announcements/:uuid" component={AnnouncementDetails} />
        <Route exact path="/announcements/minor/:uuid" component={MinorVersionDetails} />
        <Route exact path="/newusers" component={NewUsers} />
        <Route exact path="/content/tags" component={ContentTags} />
        <Route exact path="/content/tags/:slug_name" component={ContentTagsBySlug} />
        <Route exact path="/invalidate-cache" component={InvalidateCache} />

        <Route exact path="/content/blogs" component={ContentBlogs} />
        <Route
          exact
          path="/tag_associations/:association_type/:association_id"
          component={TagAssociations}
        />

        <Route exact path="/consults/past" component={PastConsults} />
        <Route exact path="/consults/future" component={FutureConsults} />
        <Route exact path="/consults/details/:uuid" component={ConsultDetails} />
        <Route exact path="/test" component={NewTesting} />
        <Route exact path="/student/notifications/:uuid" component={StudentNotifications} />
        <Route exact path="/download" component={DownloadData} />
        <Route exact path="/sms_report" component={SmsReport} />
        <Route exact path="/sms_report/v3" component={SmsReportV3} />
        <Route exact path="/ten_days_inactive_users" component={InactiveMembers} />
        <Route exact path="/banned_students" component={BannedStudents} />
        <Route exact path="/extra_participant_charges" component={ExtraParticipantCharges} />
        <Route exact path="/failedrecurringtransactions" component={FailedRecurringTransactions} />
        <Route exact path="/teacheremaillogs" component={TeacherEmailLogs} />
        <Route exact path="/ywf_repeat_groups" component={Groups} />
        <Route exact path="/ywf_repeat_groups/:uuid" component={GroupDetails} />
        <Route exact path="/community_class" component={CommunityClassesRequest} />
        <Route exact path="/gpt_session_notes" component={GptSessionNotes} />
        <Route exact path="/qa_scores" component={GptSessionQaScores} />
        <Route exact path="/gpt_session_notes/session_summary" component={SessionSummary} />
        <Route exact path="/promote_class" component={PromoteGrpClass} />
        <Route exact path="/profanity_list" component={ProfanityList} />
        <Route exact path="/blockedmessages" component={BlockedMessages} />
        <Route exact path="/teacherareamap" component={TeacherAreaMap} />
        <Route exact path="/inventory" component={Inventory} />
        <Route path="/user_timeline/:user_type/:uuid" component={UserTimeline} />
        <Route path="/email_timeline/:user_type/:uuid" component={EmailTimeline} />
        <Route exact path="/invalidate" component={Invalidate} />
        <Route exact path="/upload_teacher_payments" component={TeacherPayments} />
        <Route exact path="/concierge/lifestyle" component={Concierge} />
        <Route exact path="/concierge/lifestyle/v2" component={ConciergeV2} />
        <Route exact path="/concierge/lifestyle/v3" component={ConciergeV3} />
        <Route
          exact
          path="/concierge/lifestyle/post-trial-buckets"
          component={ConciergePostTrialBuckets}
        />
        <Route exact path="/concierge/backpain" component={Concierge} />
        <Route exact path="/press_pages" component={PressPages} />
        <Route exact path="/pricing_links" component={PricingLinks} />
        <Route exact path="/concierge-pods" component={ConciergePods} />
        <Route exact path="/vidya" component={YogaCuesLibrary} />
        <Route exact path="/vidya/:cat/:title/:seg" component={YogaCuesLibrary} />
        <Route exact path="/concierge-pods/regions" component={ConciergePodsRegions} />
        <Route exact path="/concierge-pods/report" component={ConciergePodsReport} />
        <Route
          exact
          path="/concierge-pods/team-assignments"
          component={ConciergePodsTeamAssignments}
        />
        <Route exact path="/concierge-pods/reassignments" component={ConciergePodsReassignments} />
        <Route exact path="/flagged_sms" component={FlaggedSMS} />
        <Route exact path="/chat-groups" component={GroupChats} />

        <Route exact path="/zoom-meeting-users" component={ZoomMeetingUsers} />
        <Route exact path="/magic-links" component={MagicLinkCampaigns} />
        <Route exact path="/feedback-forms" component={index} />
        <Route exact path="/session_score_card/create" component={CreateSessionFeedback} />
        <Route exact path="/session_score_card" component={SessionFeedbackFormDetails} />
        <Route exact path="/session_score_card/edit" component={EditSessionFeedback} />
        <Route exact path="/email-templates-list" component={EmailTemplatesNew} />
        <Route exact path="/short-urls" component={ShortUrlLinks} />
        <Route exact path="/session-video-chapter" component={VideoChapters} />

        <Route exact path="/teacher-application" component={TeacherApplication} />
        <Route exact path="/personalised-plan" component={PersonalizedPlanPage} />
        <Route exact path="/reminders" component={Reminders} />
        <Route exact path="/early-retention-checklist" component={EarlyRetentionChecklist} />
        <Route
          exact
          path="/early-retention-checklist-form"
          component={EarlyRetentionChecklistFormPage}
        />
        <Route exact path="/sales-task-list" component={SalesTaskList} />
        <Route exact path="/sales-task-form" component={SalesTaskFormPage} />
        <Route exact path="/profile" component={Profile} />
        <Route exact path="/cms-users" component={CmsUsers} />
        <Route exact path="/cms-users-config" component={CmsUsersConfig} />
      </Switch>
    );
  };

  render() {
    const drawer_class = this.state.drawer_open ? 'drawer' : 'drawer drawer-close';
    const content_class = this.state.drawer_open ? 'content' : 'content content-full-screen';
    if (this.props.cms_token === '') {
      const url = new URL(window.location.href);
      const redirect = `/?redirect_url=${url.pathname}${url.search}`;
      return <Redirect to={redirect} />;
    }
    const show_twilio_toggle =
      Array.isArray(this.props.access_pages) &&
      this.props.access_pages.indexOf('/twilio-agent') !== -1;

    const isFullScreenPage = window.location.pathname === '/personalised-plan';
    if (isFullScreenPage) {
      if (this.props.permissions_status !== 'success') {
        return <CustomLoading />;
      }
      return <>{this.render_switch()}</>;
    }

    return (
      <div className="home-container">
        <div className="header">
          <div className="header-logo-cont">
            <a href="/">
              <img
                className="home-logo"
                src="https://images.myyogateacher.com/web_images/web_prod/mobileHeaderIcon.png"
                alt="logo"
              />
            </a>
            <img
              className="home-menu-icon"
              onClick={this.toggle_drawer}
              src="https://images.myyogateacher.com/website/ic_menu_white.png"
              alt="menu"
            />
          </div>
          <div className="header-email">
            {show_twilio_toggle && (
              <div className="mr-6">
                <TwilioAvailabilityToggle />
              </div>
            )}
            <div className="header-timezone">
              <div className="header-timezone-title hidden sm:block">Timezone: </div>
              <TimezoneDropdown
                timezones={ianaTimezones}
                value={this.props.iana_timezone}
                onChange={this.set_time_zone}
                name="timezone"
              />
            </div>
            <ThemeToggle />
            <div className="header-email-logout">
              <Link to="/profile" className="header-email-link" title="My Profile">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="header-profile-icon"
                >
                  <path
                    d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8Z M3 14C3 11.7909 5.23858 10 8 10C10.7614 10 13 11.7909 13 14"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>{(this.props.cms_user_name || '').split(' ')[0]}</p>
              </Link>
              <div
                className="home-logout"
                onClick={this.props.log_out}
                role="button"
                tabIndex={0}
                aria-label="Log out"
                title="Log out"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.props.log_out();
                  }
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="logout-icon"
                >
                  <path
                    d="M6 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H6M10 11L14 8M14 8L10 5M14 8H6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        {this.props.permissions_status === 'success' ? (
          <div className="content-container">
            <div className={drawer_class}>
              <Drawer
                access_pages={this.props.access_pages}
                log_out={this.props.log_out}
                toggle_drawer={this.toggle_drawer}
              />
            </div>
            <div className={content_class}>{this.render_switch()}</div>
          </div>
        ) : (
          <CustomLoading />
        )}
        <ChatWindowManager />
        <GlobalIncomingCallManager />
        <GlobalOutboundCallManager />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cms_token: state.home.cms_token,
  home_component_index: state.home.home_component_index,
  iana_timezone: state.home.iana_timezone,
  permissions_status: state.loading.permissions_status,
  access_pages: state.home.access_pages,
  access_type: state.home.access_type,
  config_status: state.loading.config_status,
  config_values: state.home.config_values,
  cms_user_name: state.home.cms_user_name
});

const mapDispatchToProps = (dispatch) => ({
  log_out: () => dispatch(actions.log_out()),
  set_home_variable: (key, payload) => dispatch(actions.set_home_variable(key, payload)),
  get_permissions: () => dispatch(actions.get_permissions()),
  get_config: () => dispatch(actions.get_config())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
